import { render, staticRenderFns } from "./TableSubscriptionweb.vue?vue&type=template&id=2c6f68bc&scoped=true&"
import script from "./TableSubscriptionweb.vue?vue&type=script&lang=js&"
export * from "./TableSubscriptionweb.vue?vue&type=script&lang=js&"
import style0 from "./TableSubscriptionweb.vue?vue&type=style&index=0&id=2c6f68bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f68bc",
  null
  
)

export default component.exports